import { Enums, metaData } from '@cornerstonejs/core';
import { Enums as MetadataEnums } from '@cornerstonejs/metadata';
import createImage from '../createImage.js';
const { ImageQualityStatus } = Enums;
const COMPRESSED_FRAME_DATA = MetadataEnums.MetadataModules.COMPRESSED_FRAME_DATA;
function getWadorsFrameIndex(imageId) {
    const match = imageId.match(/\/frames\/(\d+)/);
    return match ? Math.max(0, Number(match[1]) - 1) : 0;
}
const asByteArray = (data) => data instanceof ArrayBuffer ? new Uint8Array(data) : data;
function concatPixelData(pixelData) {
    if (!Array.isArray(pixelData)) {
        return asByteArray(pixelData);
    }
    if (pixelData.length === 0) {
        return undefined;
    }
    if (pixelData.length === 1) {
        return asByteArray(pixelData[0]);
    }
    let totalLength = 0;
    for (const fragment of pixelData) {
        totalLength += asByteArray(fragment).length;
    }
    const result = new Uint8Array(totalLength);
    let offset = 0;
    for (const fragment of pixelData) {
        const view = asByteArray(fragment);
        result.set(view, offset);
        offset += view.length;
    }
    return result;
}
export function loadImageFromCompressedFrameRegistry(imageId, options = {}) {
    const frameIndex = getWadorsFrameIndex(imageId);
    let frameData;
    try {
        frameData = metaData.getTyped(COMPRESSED_FRAME_DATA, imageId, {
            frameIndex,
        });
    }
    catch (error) {
        return undefined;
    }
    if (!frameData?.pixelData) {
        return undefined;
    }
    const { pixelData, transferSyntaxUid } = frameData;
    const concatenated = concatPixelData(pixelData);
    if (!concatenated?.length || !transferSyntaxUid) {
        return undefined;
    }
    const start = Date.now();
    return createImage(imageId, concatenated, transferSyntaxUid, options).then((image) => {
        const out = image;
        out.imageQualityStatus = ImageQualityStatus.FULL_RESOLUTION;
        out.transferSyntaxUID = transferSyntaxUid;
        out.loadTimeInMS = Date.now() - start;
        return out;
    });
}
export default loadImageFromCompressedFrameRegistry;
